<template>
  <div id="modals-container">
    <component
      :is="modal.component"
      v-for="modal in modals"
      :key="modal.id"
      v-bind="modal.props"
      v-on="modal.on"
      @close="onClose(modal.id)"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        modals: 'core/modals',
      }),
    },

    watch: {
      $route () {
        this.$store.commit('core/deleteAllDialogs')
      },
    },

    methods: {
      onClose (id) {
        this.$store.commit('core/deleteDialog', id)
      },
    },
  }
</script>
